import { ParsedProduct } from '../types/ParsedObjects'
import { Sale } from '../types/Sale'

const parseProducts = (products: Sale['products']): Array<ParsedProduct> => {
  return products.edges.map(({ node }) => {
    return {
      databaseId: node.databaseId,
      name: node.name
    }
  })
}

export { parseProducts }
